"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAsyncSlice = createAsyncSlice;
exports.createDeleteAsyncSlice = createDeleteAsyncSlice;
exports.createGetAsyncSlice = createGetAsyncSlice;
exports.createPatchAsyncSlice = createPatchAsyncSlice;
exports.createPostAsyncSlice = createPostAsyncSlice;
exports.createPutAsyncSlice = createPutAsyncSlice;
const lib_1 = require("../redux/lib.js");
const sonar_http_1 = require("@sonar-software/sonar-http");
const http_1 = require("../../http/index.js");
const redux_1 = require("../../lib/redux/index.js");
function createAsyncSlice(options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const { asyncActionCreators, asyncActionCreatorsMap, asyncActionTypesMap, asyncReducers, asyncState } = (0, lib_1.createAsyncRedux)(options, options.defaultRequest);
    const { httpSagaOptions = {} } = options;
    const httpOptions = {
        allowUnauthorized: httpSagaOptions.allowUnauthorized,
        cache: httpSagaOptions.cache,
        errorCodeActionCreators: [...(_a = httpSagaOptions.errorCodeActionCreators) !== null && _a !== void 0 ? _a : [], asyncActionCreatorsMap.error],
        failCodeActionCreators: [...(_b = httpSagaOptions.failCodeActionCreators) !== null && _b !== void 0 ? _b : [], asyncActionCreatorsMap.failed],
        preRequestActionCreators: [...(_c = httpSagaOptions.preRequestActionCreators) !== null && _c !== void 0 ? _c : []],
        requestHandler: options.requestHandler,
        statusCodeHandlers: [...(_d = httpSagaOptions.statusCodeHandlers) !== null && _d !== void 0 ? _d : []],
        successActionCreators: [...(_e = httpSagaOptions.successActionCreators) !== null && _e !== void 0 ? _e : []],
        successCombinationActionCreators: [...(_f = httpSagaOptions.successCombinationActionCreators) !== null && _f !== void 0 ? _f : []],
        successDataActionCreators: [...(_g = httpSagaOptions.successDataActionCreators) !== null && _g !== void 0 ? _g : []],
        successDataHandlers: [...(_h = httpSagaOptions.successDataHandlers) !== null && _h !== void 0 ? _h : []]
    };
    if (options.receive) {
        httpOptions.successDataActionCreators = [
            ...(_j = httpSagaOptions.successDataActionCreators) !== null && _j !== void 0 ? _j : [],
            asyncActionCreatorsMap.receive
        ];
    }
    else {
        httpOptions.successActionCreators = [
            ...(_k = httpSagaOptions.successActionCreators) !== null && _k !== void 0 ? _k : [],
            asyncActionCreatorsMap.receive
        ];
    }
    const httpSaga = (0, http_1.createHttpSaga)(httpOptions);
    const watcherSteps = [
        {
            action: asyncActionTypesMap.request,
            actionHandler: httpSaga,
            type: (_l = options.yieldType) !== null && _l !== void 0 ? _l : redux_1.SagaYieldType.Latest
        },
        ...(_o = (_m = options.additionalReceiveSteps) === null || _m === void 0 ? void 0 : _m.map((step) => (Object.assign(Object.assign({}, step), { action: asyncActionTypesMap.receive })))) !== null && _o !== void 0 ? _o : [],
        ...(_q = (_p = options.additionalRequestSteps) === null || _p === void 0 ? void 0 : _p.map((step) => (Object.assign(Object.assign({}, step), { action: asyncActionTypesMap.request })))) !== null && _q !== void 0 ? _q : []
    ];
    const watcherSaga = (0, redux_1.createWatcherSaga)(watcherSteps);
    return {
        asyncActionCreators,
        asyncReducers,
        asyncState,
        asyncWatchers: watcherSaga
    };
}
function createDeleteAsyncSlice(options) {
    return createAsyncSlice(Object.assign(Object.assign({}, options), { httpVerb: sonar_http_1.HttpVerb.Delete }));
}
function createGetAsyncSlice(options) {
    return createAsyncSlice(Object.assign(Object.assign({}, options), { httpVerb: sonar_http_1.HttpVerb.Get }));
}
function createPatchAsyncSlice(options) {
    return createAsyncSlice(Object.assign(Object.assign({}, options), { httpVerb: sonar_http_1.HttpVerb.Patch }));
}
function createPostAsyncSlice(options) {
    return createAsyncSlice(Object.assign(Object.assign({}, options), { httpVerb: sonar_http_1.HttpVerb.Post }));
}
function createPutAsyncSlice(options) {
    return createAsyncSlice(Object.assign(Object.assign({}, options), { httpVerb: sonar_http_1.HttpVerb.Put }));
}
//# sourceMappingURL=lib.js.map